import { render, staticRenderFns } from "./skeleton.component.vue?vue&type=template&id=bf47a730&scoped=true"
import script from "./skeleton.component.vue?vue&type=script&lang=ts"
export * from "./skeleton.component.vue?vue&type=script&lang=ts"
import style0 from "./skeleton.component.vue?vue&type=style&index=0&id=bf47a730&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf47a730",
  null
  
)

export default component.exports